import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { QrInviteModal } from '@/components/admin/QrInviteModal';
import styles from './InviteButton.module.css';

interface InviteButtonProps {
  slug: string;
}

/**
 * Crew-Einladung für jeden eingeloggten Trip-User: öffnet ein Sheet mit dem
 * dauerhaften Einladungs-QR-Code und -Link (siehe QrInviteModal). Der Link
 * führt zur Register-Form ohne Trip-Passwort und ist mehrfach nutzbar.
 */
export function InviteButton({ slug }: InviteButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Crew-Einladung</div>
      <span className={styles.hint}>
        Zeig den QR-Code oder teile den Link — wer ihn scannt, kann ohne Trip-Passwort beitreten.
      </span>
      <Button variant="secondary" onClick={() => setOpen(true)}>
        🎟️ Crew einladen / QR anzeigen
      </Button>
      <QrInviteModal slug={slug} open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
